import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { setRebateBrokers } from '@/redux/rebate/rebateSlice';

import rebateService from '@/services/rebateService';

const getRebateBrokers = () => async dispatch => {
  try {
    const response = await rebateService.getRebateBrokers();
    const {
      data: { items },
    } = response;

    dispatch(setRebateBrokers(items));
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request GetRebateBrokers failure',
    );
  }
};

export default {
  getRebateBrokers,
};
